import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Compat route: /agendar-visita redirects to home and auto-opens the AgendarModal.
 * Useful for ads/WhatsApp campaign links that point to /agendar-visita.
 */
export default function AgendarRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/', { replace: true });
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('sm:open-agendar'));
    }, 250);
  }, [navigate]);
  return null;
}
